import DashboardTitle from './DashboardTitle.jsx'
import './DashboardTitle.less'

export default DashboardTitle
